import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import ReactPixel from 'react-facebook-pixel';
import { trackInitiateCheckout } from '../App';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (approx 600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-378">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden" style={{
      background: 'linear-gradient(to top, #0a0a0a 80%, transparent)',
      paddingBottom: 'env(safe-area-inset-bottom)'
    }} data-id="element-379">
          <div className="px-4 py-3" data-id="element-380">
            <Button size="lg" className="w-full text-base" onClick={() => {
          trackInitiateCheckout();
          window.open('https://pzhbwp-zj.myshopify.com/cart/43946659938439:1', '_blank');
        }} data-id="element-381">
              RESERVAR MI LUGAR — $19.000
            </Button>
            <p className="text-center text-[10px] text-[#C9A84C] mt-1.5 tracking-wide font-medium" data-id="element-382">
              ✉ Link del grupo llega a tu Gmail al instante · Solo 20 lugares
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}